/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { NgModule } from '@angular/core';
import { PolygonSelectModePanelComponent } from './polygon-select-mode-panel.component';
import { polygonSelectFactory } from './polygon-select.factory';
import { POLYGON_SELECT_COMMAND } from './polygon-select.token';

@NgModule({
    imports: [ PolygonSelectModePanelComponent ],
    providers: [ { provide: POLYGON_SELECT_COMMAND, useFactory: polygonSelectFactory } ]
})
export class PolygonSelectModule {}
